import {classNames, observer, pluralize, React, toJS, _, useEffect, Fragment} from '@api'
import {NoImagePlaceholder, useNestedCardItemsStore} from '@modules'
import {ImageRecord} from '@stores/catalog'
import {icons} from '@stores/ui'
import * as css from './NestedMiniBuilderCard.css'
import {MyImage, PrimaryIconButton} from 'centric-ui-components'

export const NestedMiniBuilderCard = observer(function NestedSwatches({data, className, ...props}: { data?: any, className?: string, onContextMenu?: React.MouseEventHandler<any> }) {
  const store = useNestedCardItemsStore(),
    {catalog, props: {field, field: {card}}, nestedSwatchEvents, library, cardFieldStore: {
      data: parentItemData, promoteNestedItem, associatedWorkspace, isArray, editable, 
      removeNestedItem, dataMap, nestedItemsAsList: itemAsList, cardStore: {props: {isPopover, disableSelection}}
    }} = store,
    imageRaw = _.get(data, dataMap.images),
    image : ImageRecord = !imageRaw ? null : _.isArray(imageRaw) ? _.first(imageRaw) : imageRaw,
    hex = data.hex,
    id = catalog.idFor(data, false),
    activeField = catalog.activeFieldFor(associatedWorkspace),
    isActive = _.get(data, activeField),
    refField = field?.refField,
    isItemPromoted = _.get(parentItemData, refField)?.exId === data.exId,
    renderSpecAsText = field?.renderer == "text",
    isRefFieldVisible = catalog.cardView[refField]?.show == true,
    allowedNestedDragHandlers = !isItemPromoted ? store.nestedDragHandlers(field, true, {id, dragType: 'Nested Item', target: catalog.index, targetExtra: {data}}) : {}
  // For EF concepts we don't have active field on the imported/created colorColorways sub fields, instead go get it from the real color index
  // Super expensive to do this
  // useAsync(async () => {
  //   if (!catalog.isOfflineItem(data) && !_.has(data, activeField)) {
  //     const r = await es.get({index: associatedWorkspace.catalog.index, id, _source: [activeField]})
  //     const isActive = _.get(r, activeField) || false
  //     console.debug(`Updating active field from remote query`, {isActive, activeField, data})
  //     _.set(data, activeField, isActive)  // Will cause infinite loop right now due to server bugs
  //   }
  // }, [isActive !== undefined, catalog.es.refetchId])

  //console.log(toJS({data, activeField, isActive}, {recurseEverything: true}))

  return <div
    className={classNames(css.root, className)}
    data-has-image={!!image}
    data-has-hex={!!hex ?? false}
    data-text={renderSpecAsText}
    data-type='NestedMiniBuilderCard'
    data-id={id}
    draggable={!isPopover && !disableSelection && isRefFieldVisible && !isItemPromoted}
    {...props}
    {...allowedNestedDragHandlers}
    {...nestedSwatchEvents({data, field, image})}
    >
    {editable && isArray && <Fragment>
    {associatedWorkspace && !isItemPromoted &&
        <PrimaryIconButton
            tooltip={`${'Target '} ${pluralize(associatedWorkspace.itemName, 1)}`}
            wrapperClassName={css.promoteButton} icon={icons.arrowUp} onClick={() => promoteNestedItem(data)}/>
    }
    {associatedWorkspace && _.isBoolean(isActive) &&
        <PrimaryIconButton tooltip={`${!isActive ? 'Activate' : 'Deactivate'} ${pluralize(associatedWorkspace.itemName, 1)}`}
                           wrapperClassName={css.toggleActiveButton} icon={isActive ? icons.inactive : icons.active} onClick={() => catalog.mutations.toggleBooleanField({value: isActive, field: activeField, index: associatedWorkspace.catalog.index, data: data })}/>
    }
    {associatedWorkspace && !isItemPromoted &&
     <PrimaryIconButton wrapperClassName={css.deleteButton}
                        tooltip={`Remove this ${pluralize(associatedWorkspace.itemName, 1)}`}
                        icon={'cross'} onClick={() => removeNestedItem(data)} />
    }
    </Fragment>}

    {!renderSpecAsText && (!image ? <NoImagePlaceholder className={css.fieldValue} /> /* placeholderText={_.first(library?.name ?? catalog.labelForField(field) ?? 'U')} */
            : hex ? <div style={{background: hex}} className={css.hex}/>
                  : <MyImage className={css.image}
                             imageUrl={catalog.imageUrlFor(image)}
                             imageId={image.exId}
                             blurOnLoad/>)}
    {isActive === false && <div className={classNames(css.diagonal)}/>}
    {renderSpecAsText || itemAsList ? <span className={css.fieldValue}>
                        {(card?.nestedTitleFields?.length && _.get(data, card?.nestedTitleFields[0])) ?? ''}
                      </span> : null}
  </div>
})



// WEBPACK FOOTER //
// ./src/modules/catalog/product/productCard/components/BuilderCard/NestedCardItems/NestedMiniBuilderCard.tsx